import React from 'react'

const SecurityComplaince = () => {
  return (
    <div>SecurityComplaince</div>
  )
}

export default SecurityComplaince